/* eslint-disable camelcase */
import { mapMutations } from 'vuex'

import {
  UPDATE_LOADER,
  FNOL_MODULE_NAME,
  FNOL_UPDATE_ID_FLUX
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { apiGetUserSettings } from '@/modules/User/services/authentication'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'home',

  mixins: [flowMixin],

  methods: {
    ...mapMutations(FNOL_MODULE_NAME, {
      mutFnolIdFlux: FNOL_UPDATE_ID_FLUX
    }),
    async handleFlowData() {
      try {
        const flowData = await this.getStateFlowData()
        const { flow, e2eFlow, smartFluxId, state, transitions, options } =
          flowData
        this.setFlowName(flow)

        this.setFlowE2EFlow(e2eFlow)

        this.setFlowState(state, transitions)
        if (options.content) this.setViewContent(options.content)
        this.setViewOptions(options)
        this.setFluxData(smartFluxId)

        const sinisterId = sessionStorage.getItem('sinId')
        const { lang, country_code, company_icon, color_primary, company } = await apiGetUserSettings(
          sinisterId
        )

        this.setFlowCompany(company)
        this.setFlowCompanyColor(color_primary)
        this.setFlowCompanyIcon(company_icon)
        this.initI18n(lang)
        localStorage.setItem('mavCountryCode', country_code)

        return flowData
      } catch (error) {
        this.$store.commit(UPDATE_LOADER, false)

        const context = {
          component: 'home',
          method: 'handleFlowData',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error loading flow data: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          sessionStorage.getItem('sinId'),
          'handleFlowData'
        )

        this.goToErrorView(error)
      }
    },
    matchLocale: function (locale) {
      const locales = this.$i18n.availableLocales
      if (locales.length <= 0) return
      return locales.indexOf(locale) !== -1 ? locale : locales[0]
    },

    initI18n: function (lang) {
      if (typeof Storage !== 'undefined') {
        let current
        if (lang) {
          current = this.matchLocale(lang)
        } else if (localStorage.getItem('locale')) {
          current = this.matchLocale(localStorage.getItem('locale'))
        } else {
          current = 'fr'
        }
        this.$i18n.locale = current
        localStorage.setItem('locale', current)
      }
    },

    setFluxData(fluxId) {
      this.mutFnolIdFlux(fluxId)
    },

    async handleUserRedirect() {
      this.$store.commit(UPDATE_LOADER, false)
      this.goToView(this.getFlowStateViewName)
    }
  },

  async mounted() {
    this.$store.commit(UPDATE_LOADER, true)
    await this.handleFlowData()
    await this.handleUserRedirect()
  }
}
